export const safeConcatWith =
  (separator: string = ' ') =>
  (...pieces: unknown[]): string => {
    return pieces.filter(Boolean).join(separator);
  };

export const safeConcat = (...pieces: any[]) => {
  return safeConcatWith()(...pieces);
};
